<template>
  <main>
    <div class="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/">HARUMIFLAG</router-link></li>
          <li><router-link to="/myfavoritethings/form">写真を投稿する</router-link></li>
        </ul>
      </div>
    </div>
    <div class="contact">
      <div class="contact__title">
        <div class="container">
          <h2>MY FAVORITE THINGS<span>私のお気に入り</span></h2>
          <h2>写真を投稿する</h2>
          <ul class="contact__process step2">
            <li>
              <span>1.入力</span>
            </li>
            <li class="active">
              <span>2.確認</span>
            </li>
            <li>
              <span>3.完了</span>
            </li>
          </ul>
          <p>内容ご確認の上、「送信する」ボタンを押してください</p>
        </div>
      </div>
      <div class="contact__content">
        <div class="container">
          <form class="form form--confirm" @submit.prevent="submitComplete">
            <!-- Theme name -->
            <div class="form__row">
              <div class="form__title">
                <label>応募するテーマ<span class="required">必須</span></label>
              </div>
              <div class="form__content">
                <p class="form__answ">{{ contact_meta.theme_name }}</p>
              </div>
            </div>
            <!-- fullname -->
            <div class="form__row">
              <div class="form__title">
                <label>氏名<span class="required">必須</span></label>
              </div>
              <div class="form__content">
                <p class="form__answ">{{ contact_meta.last_name + ' ' + contact_meta.first_name }}</p>
              </div>
            </div>
            <!-- residence -->
            <div class="form__row">
              <div class="form__title">
                <label>お住まい<span class="required">必須</span></label>
              </div>
              <div class="form__content">
                <p class="form__answ">{{ contact_meta.block + ' ' + contact_meta.building + ' ' + contact_meta.room_number }}</p>
              </div>
            </div>
            <!-- nickname -->
            <div class="form__row">
              <div class="form__title">
                <label>ニックネーム<span class="required">必須</span></label>
              </div>
              <div class="form__content">
                <p class="form__answ">{{ contact_meta.nick_name }}</p>
              </div>
            </div>
            <!-- email -->
            <div class="form__row">
              <div class="form__title">
                <label>メールアドレス<span class="required">必須</span></label>
              </div>
              <div class="form__content">
                <p class="form__answ">{{ contact_meta.email_address }}</p>
              </div>
            </div>
            <!-- phone -->
            <div class="form__row">
              <div class="form__title">
                <label>電話番号<span class="required">必須</span></label>
              </div>
              <div class="form__content">
                <p class="form__answ">{{ contact_meta.phone_number }}</p>
              </div>
            </div>
            <!-- photo image -->
            <div class="form__row">
              <div class="form__title">
                <label>画像<span class="required">必須</span></label>
              </div>
              <div class="form__content">
                <!-- <img :src="'/img/top/' + contact_meta.photo_image" />  -->
                <img :src="contact_meta.fileUrl" /> 
                <!-- <img v-if="contact_meta.fileType != 'image/heic'" :src="contact_meta.fileUrl" /> 
                <p v-else class="form__answ">このファイル形式はプレビューできません。</p> -->
              </div>
            </div>
            <!-- content -->
            <div class="form__row mb_doube">
              <div class="form__title">
                <label>コメント<span class="required">必須</span></label>
              </div>
              <div class="form__content">
                <p class="form__answ">{{ contact_meta.comment }}</p>
              </div>
            </div>
            <div class="form__row">
              <div class="form__content">
                <p class="form__note">入力画面に戻る場合は、必ずこの「修正する」ボタンをクリックして戻ってください。</p>
              </div>
            </div>
          </form>
          <div class="outside__form">
            <div v-if="isLoading" class="form__button">
              <button class="btn btn--white icon--blue" disabled>修正する</button>
              <button class="btn btn--send icon--white" disabled>送信する</button>
            </div>

            <div v-else class="form__button">
              <button @click="backForm" class="btn btn--white icon--blue">修正する</button>
              <button @click="submitComplete" class="btn btn--send icon--white">送信する</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>

</template>

<script>
import { RouterLink } from 'vue-router';
import { metaData, validateNumber } from '@/utils/helper';
import axios from "axios";
import indexedDB from '@/utils/indexedDB';

export default {
  name: 'MyfavoritethingsFormConfirm',
  props: ['data'],
  data() {
    return {
      contact_meta: {
        theme_name: "",
        first_name: "",
        last_name: "",
        block: "",
        building: "",
        room_number: "",
        nick_name: "",
        email_address: "",
        phone_number: "",
        photo_image: "",
        comment: "",
        fileName: "",
        fileUrl: ""
      },
      isLoading: false,
    };
  },

  methods: {
    async fetchPhotoFromIndexedDB() {
      try {
        const photo = await indexedDB.getItem('photo_image');
        
        if (photo) {
          this.contact_meta.photo_image = photo;
          if (!this.contact_meta.fileUrl) {
            this.contact_meta.fileUrl = URL.createObjectURL(photo);
          }
        }
      } catch (error) {
        console.error('Failed to fetch photo from IndexedDB:', error);
      }
    },

    async submitComplete() {
      this.isLoading = true;
      const formData = new FormData();

      for (const key in this.contact_meta) {
        formData.append(key, this.contact_meta[key]);
      }

      await axios.post('/api/myfavoritethings/form/submit', formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then((response) => {
        if (response.data?.result == true) {
          this.$router.push({
            name: 'MyfavoritethingsFormComplete',
          });
        } else {  
          this.$router.push({
            name: 'MyfavoritethingsFormError'
          });
        }
      })
      .catch((error) => {
          this.$router.push({
            name: 'MyfavoritethingsFormError'
          });
      }).finally(() => {
        this.isLoading = false;
      });
    },

    backForm() {
      this.$router.push({ name: 'MyfavoritethingsForm', params: { isEdit: true } });
    },
  },
  created() {
    if (sessionStorage.getItem('token') == null || sessionStorage.getItem('validated_inputform') == null) {
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('validated_inputform')
      sessionStorage.removeItem('validated_inputform_data')
      indexedDB.clear();
      
      this.$router.push({
        name: 'Myfavoritethings',
        params: {
          isScrollToLogin: true
        }
      });
    }

    metaData(
      `写真を投稿する | HARUMIFLAGタウンポータル`,
      '中央区晴海・HARUMIFLAGのMY FAVORITE THINGS 写真を投稿するページです。',
      'HARUMIFLAGタウンポータル',
      'website'
    )
  },

  async mounted() {
    if (sessionStorage.getItem('validated_inputform_data') !== null) {
      this.contact_meta = { ...JSON.parse(sessionStorage.getItem('validated_inputform_data')) };
      try {
        const photoImage = await fetch(this.contact_meta?.fileUrl || '');
        const blob = await photoImage.blob();
        const file = new File([blob], this.contact_meta.fileName, {
          type: blob.type,
          lastModified: new Date().getTime()
        });
        this.contact_meta.photo_image = file;
      } catch (error) {
        this.contact_meta.fileUrl = '';
        await this.fetchPhotoFromIndexedDB();
      }
    }
  },
}
</script>